module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/project-detail/project-detail.component.scss
// module id = ./src/app/project-detail/project-detail.component.scss
// module chunks = main